import { Box, CircularProgress, FormControl, InputLabel, Select, TextField, Tooltip, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { DataGrid } from '@mui/x-data-grid'
import { useEffect, useMemo, useState } from 'react'
import { format } from 'date-fns'

import { isValidUser } from '../../../OnlyWithFunctions'
import Button from '@mui/material/Button'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import MenuItem from '@mui/material/MenuItem'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { useForm } from 'react-hook-form'
import { LOCALE_TEXT_ITA } from '../../../Charts/LOCALE_TEXT_ITA'
import Grid from '@mui/material/Grid'
import { getAccountingAdv } from '../../../services/getAccountingAdv'
import * as XLSX from 'xlsx'
import dayjs from 'dayjs'
const statoPratica = [
  "In Richiesta", "In Lavorazione", "In Attesa Opzionali", "Info Complete",
  "Check Out Operatore", "Da Approvare", "Chiusa", "Annullata"
]
const tipiIns = ["Automatica Medio Rischio", "Automatica Alto Rischio","Manuale Medio Rischio","Manuale Alto Rischio"]
const AccountingAdv = () => {
  const [listaPratiche, setListaPratiche] = useState([])
  const [filteredRows, setFilteredRows] = useState([])
  const [isLoading, setIsLoading] = useState(false)


  const theme = useTheme()

  const { register, handleSubmit, setValue, getValues, watch } = useForm({
    defaultValues: {
      dataAperturaDal: null,
      dataAperturaAl: null,
      dataChiusuraDal: null,
      dataChiusuraAl: null,
      statoPraticaList: [],
      tipoInserimentoList: []
    },
  })

  const watchAll = watch()

  const onFilter = async (data) => {
    console.log("CI ARRIVO")
    setIsLoading(true)
    try {
      const response = await getAccountingAdv({ body: data });
      setListaPratiche(response || []);
      setIsLoading(false)
    } catch (error) {
      console.error('Errore durante il recupero delle pratiche:', error);
      setListaPratiche([]);
      setIsLoading(false)
    }
  };

  const onGeneraExcel = () => {
    //setOpenFilterMenu(false)
    handleSubmit(onFilter)
    generaExcel(listaPratiche)
  }

  const generaExcel = (lista) => {
    if (!lista || lista.length === 0) {
      console.log('Nessun dato disponibile per l\'export.')
      return
    }

    // Mappa i dati per l'export in Excel
    const ws = XLSX.utils.json_to_sheet(
      lista.map(item => ({
        NDG: item.ndg,
        'Codice Fiscale': item.codiceFiscale,
        'Ragione Sociale': item.ragioneSociale,
        'Data Apertura': item.dataCreazione ? dayjs(item.dataCreazione).format('DD/MM/YY') : '',
        'Data Chiusura': item.dataChiusura ? dayjs(item.dataChiusura).format('DD/MM/YY') : '',
        'Stato Pratica': item.statoPratica,
        'Tipo Inserimento': item.tipoInserimento,
        'Documenti Generati': item.documentiGenerati ? item.documentiGenerati : 0,
        'Esito Monitoraggio': item.esitoMonitoraggio ? 'Si' : 'No',
      })),
    )
    // Crea un nuovo workbook
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Pratiche')

    // Scrive il file Excel con il nome desiderato
    XLSX.writeFile(wb, 'Lista_Pratiche.xlsx')


  }

  const columns = useMemo(
    () => [
      {
        field: 'ndg',
        headerName: 'NDG',
        type: 'string',
        filterable: false,
        flex: 1,
        valueGetter: params => params.row['ndg'],
        renderCell: params => (
          <Tooltip
            title={params.row['ndg']}
            followCursor
          >
            <Typography className="table-cell-trucate">
              {params.row['ndg']}
            </Typography>
          </Tooltip>
        ),
      },
      {
        field: 'codiceFiscale',
        headerName: 'Codice Fiscale',
        filterable: false,
        flex: 1,
        valueGetter: params =>
          params.row['codiceFiscale'],

        renderCell: params => (
          <Tooltip
            title={params.row['codiceFiscale']}
            followCursor
          >
            <Typography className="table-cell-trucate">
              {params.row['codiceFiscale']}
            </Typography>
          </Tooltip>
        ),
      },
      {
        field: 'ragioneSociale',
        headerName: 'Ragione Sociale',
        filterable: false,
        flex: 1,
        valueGetter: params =>
          params.row['ragioneSociale'],

        renderCell: params => (
          <Tooltip
            title={params.row['ragioneSociale']}
            followCursor
          >
            <Typography className="table-cell-trucate">
              {params.row['ragioneSociale']}
            </Typography>
          </Tooltip>
        ),
      },
      {
        field: 'dataApertura',
        type: 'date',
        headerName: 'Data Apertura',
        filterable: false,
        flex: 1,
        valueGetter: params => params?.row?.createdAt,

        renderCell: params =>
          params?.row.dataCreazione ? format(new Date(params?.row.dataCreazione), 'dd/MM/yyyy') : '',
      },
      {
        field: 'dataChiusura',
        headerName: 'Data Chiusura',
        filterable: false,
        flex: 1,
        valueGetter: params =>
          params.row['dataChiusura'],
        renderCell: params => (
          <Typography className="table-cell-truncate">
            {params?.row['dataChiusura']
              ? new Date(params.row['dataChiusura']).toLocaleDateString()
              : ''
            }
          </Typography>

        ),
      },
      {
        field: 'statoPratica',
        headerName: 'Stato Pratica',
        sortable: true,
        filterable: false,
        flex: 1,
        valueGetter: params =>
          params.row['statoPratica'],
        renderCell: params => (
          <Tooltip
            title={params.row['statoPratica']}
            followCursor
          >
            <Typography className="table-cell-trucate">
              {params.row['statoPratica']}
            </Typography>
          </Tooltip>
        ),
      },
      {
        field: 'tipoInserimento',
        headerName: 'Tipo Inserimento',
        sortable: false,
        filterable: false,
        flex: 1,
        valueGetter: params =>
          params.row['tipoInserimento'],
        renderCell: params => (
          <Tooltip
            title={params.row['tipoInserimento']}
            followCursor
          >
            <Typography className="table-cell-trucate">
              {params.row['tipoInserimento']}
            </Typography>
          </Tooltip>
        ),
      },
      {
        field: 'documentiGenerati',
        headerName: 'Documenti Generati',
        sortable: true,
        filterable: false,
        flex: 1,
        valueGetter: params => params.row['documentiGenerati'],
        renderCell: params => (
          <Box display="flex" justifyContent="center" alignItems="center" width="100%">
            <Typography className="table-cell-truncate">
              {params.row['documentiGenerati']}
            </Typography>
          </Box>
        ),
      },

      {
        field: 'esitoMonitoraggio',
        headerName: 'Esito Monitoraggio',
        sortable: true,
        filterable: false,
        hide: !isValidUser('UTENTE_INTERNO'),
        flex: 1,
        valueGetter: params => {
          return params.row['esitoMonitoraggio'] ? 'Si' : 'No'
        },
        renderCell: params => {
          const esitoMonitoraggio = params.row['esitoMonitoraggio'] // booleano

          return (
            <Tooltip
              title={esitoMonitoraggio !== undefined ? (esitoMonitoraggio ? 'Si' : 'No') : 'N/A'}
              followCursor
            >
              <Box display="flex" justifyContent="center" alignItems="center" width="100%">
                <Typography className="table-cell-truncate">
                  {esitoMonitoraggio ? 'Si' : 'No'}
                </Typography>
              </Box>
            </Tooltip>
          )
        },

      },

    ],
    [],
  )

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ padding: 2, mb: 2 }}>
        <form onSubmit={handleSubmit(onFilter)}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl variant="standard" sx={{ width: "100%" }}>
                <InputLabel id="stato-pratica-label">Stato pratica</InputLabel>
                <Select
                  labelId="stato-pratica-label"
                  id="stato-pratica-select"
                  multiple
                  value={getValues("statoPraticaList") || []}
                  onChange={(e) => setValue("statoPraticaList", e.target.value)}
                  renderValue={(selected) => selected.join(", ")}
                >
                  {statoPratica.map(stato => (
                    <MenuItem key={stato} value={stato}>{stato}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl variant="standard" sx={{ width: "100%" }}>
                <InputLabel id="tipo-inserimento-label">Tipo Inserimento</InputLabel>
                <Select
                  labelId="tipo-inserimento-label"
                  id="tipo-inserimento-select"
                  multiple
                  value={getValues("tipoInserimentoList") || []}
                  onChange={(e) => setValue("tipoInserimentoList", e.target.value)}
                  renderValue={(selected) => selected.join(", ")}
                >
                  {tipiIns.map(stato => (
                    <MenuItem key={stato} value={stato}>{stato}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Apertura dal"
                  value={watch('dataAperturaDal')}
                  onChange={(value) => setValue('dataAperturaDal', value ? value.toISOString() : null)}
                  renderInput={(params) => <TextField variant="standard" {...params} />}
                />
                <DatePicker
                  label="Apertura al"
                  value={watch('dataAperturaAl')}
                  onChange={(value) => setValue('dataAperturaAl', value ? value.toISOString() : null)}
                  renderInput={(params) => <TextField variant="standard" {...params} />}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Chiusura dal"
                  value={watch('dataChiusuraDal')}
                  onChange={(value) => setValue('dataChiusuraDal', value ? value.toISOString() : null)}
                  renderInput={(params) => <TextField variant="standard" {...params} />}
                />
                <DatePicker
                  label="Chiusura al"
                  value={watch('dataChiusuraAl')}
                  onChange={(value) => setValue('dataChiusuraAl', value ? value.toISOString() : null)}
                  renderInput={(params) => <TextField variant="standard" {...params} />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={2} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', gap: 2 }}>
              <Button type="submit" variant="outlined">
                Filtra
              </Button>
              <Button
                variant="outlined"
                onClick={onGeneraExcel}
              >
                Genera Excel
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
      {isLoading ? (
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', py: 10 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            height: 526,
            width: '100%',
            '& .utenteBase': {
              backgroundColor: theme.palette.grey.light,
              color: theme.palette.black,
            },
            '& .fieldAnalyst': {
              backgroundColor: theme.palette.blue.light,
              color: theme.palette.black,
            },
          }}
        >
          <DataGrid
            disableSelectionOnClick
            sx={{ cursor: 'url(hand.cur), pointer' }}
            rows={listaPratiche}
            columns={columns}
            getRowId={row => row.id}
            localeText={LOCALE_TEXT_ITA}
            sortingOrder={['asc', 'desc']}
            sortingMode="server"
            pagination={false}
          />
        </Box>
      )}
    </Box>
  )
}
export default AccountingAdv
